import CopyToClipboard from "../../copyToClipboard";
import UseContext from "../../../hooks/useContext";
import useSlideOver from "../../SlideOver/useSlideOver";
import {CheckIcon, NegativeThumb, PositiveThumb} from "../../../assets/icons";
import {useLocation} from "react-router-dom";
import useModal from "../../modal/useModal";
import React, {useEffect, useState} from "react";
import Button from "../../button";
import TableRow from "./TableRow";
import TableCell from "./TableCell";
import ClickableText from "./ClickableText";
import {useNavigate} from "react-router-dom";

const TbodyVivierRatingTempWorker = ({ champsBody }) => {
    const { setObjID, reviewUntreatedDelete } = UseContext()
    const [reviews, setReviews] = useState(champsBody)
    const {toggle} = useModal()
    const { toggleSlideOver } = useSlideOver();
    const pathname = useLocation().pathname
    const location = useLocation();
    const navigate = useNavigate();
    const [selectedId, setSelectedId] = useState(null);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const id = params.get('idRating');
        if (id) {
            setSelectedId(id);
        }
    }, [location]);

    const openCompanyInfo = (id) => {
        setObjID(id)
        toggleSlideOver('get_company')
    }

    const openModalRatingValidation = (id_rating) => {
        setObjID(id_rating)
        setSelectedId(id_rating)
        toggle('rating_temp_worker_validation')
        
        // Mettre à jour l'URL pour synchroniser la sélection
        const currentUrl = window.location.pathname;
        const params = new URLSearchParams(window.location.search);
        params.set('idRating', id_rating);
        window.history.replaceState({}, '', `${currentUrl}?${params.toString()}`);
    }

    useEffect(() => {
        if(reviewUntreatedDelete) {
            setReviews(reviews.filter((review) => review._id !== reviewUntreatedDelete))
        }
    }, [reviewUntreatedDelete]);

    const openTempWorkerInfo = (id) => {
        setObjID(id)
        toggleSlideOver('get_temp_worker')
    }

    return (
        <>
            {reviews?.map((rating, key) => (
                <TableRow
                    key={key}
                    itemId={rating?._id}
                    selectedId={selectedId}
                    onClick={(id) => openModalRatingValidation(id)}
                    clickable={true}
                >
                    <TableCell position="first" stickyLeft={true} isSelected={selectedId === rating?._id}>
                        <div>
                            <CopyToClipboard text={rating?.user?.firstname + ' ' + rating?.user?.lastname}>
                                <ClickableText
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        openTempWorkerInfo(rating?.user?._id);
                                    }}
                                    tooltipText="Voir le candidat"
                                >
                                    {rating?.user?.firstname} {rating?.user?.lastname}
                                </ClickableText>
                            </CopyToClipboard>
                        </div>
                        <div className={'text-gray-500 mt-1'}>
                            <CopyToClipboard text={rating?.user?.email}>
                                <a className={'underline'} href={`mailto:${rating?.user?.email}`}>
                                    {rating?.user?.email}
                                </a>
                            </CopyToClipboard>
                        </div>
                    </TableCell>
                    <TableCell>
                        <div className={'text-gray-900'}>
                            {rating?.mission?.title} n°{rating?.mission?.id_mission}
                        </div>
                        <div className={'text-gray-500 mt-1'}>
                            <ClickableText
                                onClick={(e) => {
                                    e.stopPropagation();
                                    openCompanyInfo(rating?.id_company);
                                }}
                                tooltipText="Voir l'entreprise"
                            >
                                {rating?.name_commercial}
                            </ClickableText>
                        </div>
                    </TableCell>
                    <TableCell>
                        <div className={'flex gap-2 max-w-[250px] max-h-[100px] text-ellipsis overflow-hidden'}>
                            {rating.type === 'positive' ? (
                                <div className={'my-auto w-fit rounded-full p-2 bg-green-50'}>
                                    <PositiveThumb wh={24} color={'#10B981'}/>
                                </div>
                            ) : (
                                <div className={'my-auto w-fit rounded-full p-2 bg-red-50'}>
                                    <NegativeThumb wh={24} color={'#EF4444'}/>
                                </div>
                            )}
                            <div className={'my-auto flex-1 min-w-0'}>
                                {rating.type_negative === 'performance' && (
                                    <div className={'text-gray-900'}>
                                        Performance
                                    </div>
                                )}
                                {rating.type_negative === 'professionalism' && (
                                    <div className={'text-gray-900'}>
                                        Professionnalisme
                                    </div>
                                )}
                                <div className={'text-gray-500 line-clamp-2'}>
                                    {rating?.comment}
                                </div>
                            </div>
                        </div>
                    </TableCell>
                    <TableCell className={pathname.includes('rating-untreated') ? '' : 'last'}>
                        <div className={'text-gray-500 max-w-[250px] max-h-[100px] text-ellipsis overflow-hidden'}>
                            {rating?.employee?.firstname} {rating?.employee?.lastname}
                        </div>
                    </TableCell>
                    {pathname.includes('rating-untreated') && (
                        <TableCell position="last" hasButton buttonOnClick={() => openModalRatingValidation(rating?._id)} buttonContent={<CheckIcon w={24} h={12} color={'#374151'}/>} />
                    )}
                </TableRow>
            ))}
        </>
    )
}

export default TbodyVivierRatingTempWorker